import { WmChart, WmChartSlice } from "@watermarkinsights/ripple-react";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import translate from "@/i18n/translate";
import { formatNumber, getPercentage } from "../../../src/static/js/commons";
import WidgetLoader from "../common/elements/WidgetLoader";
import ApiError from "../common/elements/ApiError";
export interface CourseCompletionRiskProps {
  highRiskCourseEngagement: number;
  lowRiskCourseEngagement: number;
  mediumRiskCourseEngagement: number;
  notIndicatedRiskCourseEngagement: number;
  highRiskCourseCompletion: number;
  lowRiskCourseCompletion: number;
  mediumRiskCourseCompletion: number;
  notIndicatedRiskCourseCompletion: number;
  loader: boolean;
  termSummaryFailed: boolean;
}

export default function CourseCompletionRisk({
  highRiskCourseEngagement,
  lowRiskCourseEngagement,
  mediumRiskCourseEngagement,
  notIndicatedRiskCourseEngagement,
  highRiskCourseCompletion,
  lowRiskCourseCompletion,
  mediumRiskCourseCompletion,
  notIndicatedRiskCourseCompletion,
  loader,
  termSummaryFailed
}: CourseCompletionRiskProps) {
  const [lowRiskPopoverState, setLowRiskPopoverState] = useState(false);
  const [mediumRiskPopoverState, setMediumRiskPopoverState] = useState(false);
  const [highRiskPopoverState, setHighRiskPopoverState] = useState(false);
  const [notIndicatedPopoverState, setNotIndicatedPopoverState] =
    useState(false);

  useEffect(() => {
    var lowRiskBtn = document.getElementById("low-risk");
    lowRiskBtn?.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && document.activeElement === lowRiskBtn) {
        setLowRiskPopoverState(!lowRiskPopoverState);
      }
    });
  }, [lowRiskPopoverState]);

  useEffect(() => {
    var mediumRiskBtn = document.getElementById("medium-risk");
    mediumRiskBtn?.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && document.activeElement === mediumRiskBtn) {
        setMediumRiskPopoverState(!mediumRiskPopoverState);
      }
    });
  }, [mediumRiskPopoverState]);

  useEffect(() => {
    var highRiskBtn = document.getElementById("high-risk");
    highRiskBtn?.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && document.activeElement === highRiskBtn) {
        setHighRiskPopoverState(!highRiskPopoverState);
      }
    });
  }, [highRiskPopoverState]);

  useEffect(() => {
    var notIndicatedBtn = document.getElementById("not-indicated");
    notIndicatedBtn?.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && document.activeElement === notIndicatedBtn) {
        setNotIndicatedPopoverState(!notIndicatedPopoverState);
      }
    });
  }, [notIndicatedPopoverState]);

  function useClosePopoverOutsideClick(ref: any) {
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setLowRiskPopoverState(false);
          setHighRiskPopoverState(false);
          setMediumRiskPopoverState(false);
          setNotIndicatedPopoverState(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  let arrOfRiskBarVal = [
    Number(lowRiskCourseEngagement),
    Number(mediumRiskCourseEngagement),
    Number(highRiskCourseEngagement),
    Number(notIndicatedRiskCourseEngagement)
  ];
  const largestRiskValue = Math.max(...arrOfRiskBarVal);

  const lowRiskCourseEnga = getPercentage(
    lowRiskCourseEngagement,
    largestRiskValue
  );

  const mediumRiskCourseEnga = getPercentage(
    mediumRiskCourseEngagement,
    largestRiskValue
  );

  const highRiskCourseEnga = getPercentage(
    highRiskCourseEngagement,
    largestRiskValue
  );

  const notIndicatedRiskCourseEnga = getPercentage(
    notIndicatedRiskCourseEngagement,
    largestRiskValue
  );

  const riskSummaryLabel = useIntl().formatMessage({
    id: "app.sse.riskSummaryLabel"
  });

  const lowRiskLabel = useIntl().formatMessage({
    id: "app.sse.lowRiskLabel"
  });

  const mediumRiskLabel = useIntl().formatMessage({
    id: "app.sse.mediumRiskLabel"
  });
  const highRiskLabel = useIntl().formatMessage({
    id: "app.sse.highRiskLabel"
  });
  const notIndicatedLabel = useIntl().formatMessage({
    id: "app.sse.notIndicatedLabel"
  });
  const riskSummaryLowRiskText = useIntl().formatMessage({
    id: "app.sse.riskSummaryLowRiskText"
  });
  const riskSummaryMediumRiskText = useIntl().formatMessage({
    id: "app.sse.riskSummaryMediumRiskText"
  });
  const riskSummaryHighRiskText = useIntl().formatMessage({
    id: "app.sse.riskSummaryHighRiskText"
  });
  const riskSummaryNotIndicatedText = useIntl().formatMessage({
    id: "app.sse.riskSummaryNotIndicatedText"
  });

  const lowRiskPopover = useIntl().formatMessage({
    id: "app.sse.lowRiskPopover"
  });

  const mediumRiskPopover = useIntl().formatMessage({
    id: "app.sse.mediumRiskPopover"
  });

  const highRiskPopover = useIntl().formatMessage({
    id: "app.sse.highRiskPopover"
  });

  const notIndicatedRiskPopover = useIntl().formatMessage({
    id: "app.sse.notIndicatedPopover"
  });

  const keyEngagementRiskLevel = useIntl().formatMessage({
    id: "app.sse.keyEngagementRiskLevel"
  });
  const wrapperRef = useRef(null);
  useClosePopoverOutsideClick(wrapperRef);

  const CourseCompletionRiskBody = () => {
    return (
      <>
        <div className="body">
          <div className="wm-grid">
            <div className="course-completion-conatiner wm-grid-row">
              <div
                id="risk-summary"
                className="risk-summary wm-grid-col-6 wm-grid-col-md-5 wm-grid-col-sm-8"
              >
                <div className="risk-summary-label">
                  {translate("app.sse.riskSummaryLabel")}
                </div>
                <WmChart
                  id="risk-summary-chart"
                  chartType="doughnut2"
                  label={riskSummaryLabel}
                  valueFormat="amount"
                  key="risk-summary-chart"
                  print-mode={true}
                >
                  <WmChartSlice
                    amount={String(lowRiskCourseCompletion)}
                    legend={lowRiskLabel}
                    popoverTitle={formatNumber(lowRiskCourseCompletion)}
                    popoverText={riskSummaryLowRiskText}
                  ></WmChartSlice>
                  <WmChartSlice
                    amount={String(mediumRiskCourseCompletion)}
                    legend={mediumRiskLabel}
                    popoverTitle={formatNumber(mediumRiskCourseCompletion)}
                    popoverText={riskSummaryMediumRiskText}
                  ></WmChartSlice>
                  <WmChartSlice
                    amount={String(highRiskCourseCompletion)}
                    legend={highRiskLabel}
                    popoverTitle={formatNumber(highRiskCourseCompletion)}
                    popoverText={riskSummaryHighRiskText}
                  ></WmChartSlice>
                  <WmChartSlice
                    amount={String(notIndicatedRiskCourseCompletion)}
                    legend={notIndicatedLabel}
                    popoverTitle={formatNumber(
                      notIndicatedRiskCourseCompletion
                    )}
                    popoverText={riskSummaryNotIndicatedText}
                  ></WmChartSlice>
                </WmChart>
              </div>
              <div
                id="key-engagement"
                className="key-engagement wm-grid-col-6 wm-grid-col-md-5 wm-grid-col-sm-8"
              >
                <div id="key-engagement-chart" className="key-engagement-chart">
                  <WmChart
                    chartType="bar7"
                    label={keyEngagementRiskLevel}
                    showLegend={false}
                    showBarLegend={true}
                    labelWidth="95px"
                    valueFormat="percentage"
                    key="course-engagment-chart"
                  >
                    <WmChartSlice
                      amount={formatNumber(lowRiskCourseEnga)}
                      legend={lowRiskLabel}
                      popoverTitle={formatNumber(lowRiskCourseEngagement)}
                      popoverText={lowRiskPopover}
                    ></WmChartSlice>
                    <WmChartSlice
                      amount={formatNumber(mediumRiskCourseEnga)}
                      legend={mediumRiskLabel}
                      popoverTitle={formatNumber(mediumRiskCourseEngagement)}
                      popoverText={mediumRiskPopover}
                    ></WmChartSlice>
                    <WmChartSlice
                      amount={formatNumber(highRiskCourseEnga)}
                      legend={highRiskLabel}
                      popoverTitle={formatNumber(highRiskCourseEngagement)}
                      popoverText={highRiskPopover}
                    ></WmChartSlice>
                    <WmChartSlice
                      amount={formatNumber(notIndicatedRiskCourseEnga)}
                      legend={notIndicatedLabel}
                      popoverTitle={formatNumber(
                        notIndicatedRiskCourseEngagement
                      )}
                      popoverText={notIndicatedRiskPopover}
                    ></WmChartSlice>
                  </WmChart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="wm-grid-col-12">
      <div className="paper-card paper-card-height">
        <div className="header">
          <div className="info">
            <h3 className="title">
              {translate("app.sse.courseCompletionRiskAndEngagement")}
            </h3>
            <p className="description -descs">
              {translate("app.sse.courseCompletionDescription")}
            </p>
          </div>
        </div>
        {loader && (
          <WidgetLoader
            loaderContainerClasses="loader"
            loaderClasses="content"
          />
        )}
        {!loader && !termSummaryFailed && <CourseCompletionRiskBody />}

        {termSummaryFailed && <ApiError />}
      </div>
    </div>
  );
}
